import React from 'react'

function Balconies() {
  return (
    <div>Balconies</div>
  )
}

export default Balconies